import React from "react";
import screenshot1 from "../../assets/img/screenshot1.png";

export default function GlAhu(){
  return(
   <img src={screenshot1} alt={' '} style={{width:'945px',marginTop:'-17px',marginLeft:'40px'}}></img>
  )
   
}